<template>
  <div class="form-container" :class="{ isMobile: isMobile }">
    <div class="auth-form">
      <h1 class="auth-title mb-6">Zapomniałeś hasło?</h1>
      <div v-if="showSuccessText" class="color-primary-purple">
        <p class="bold">
          Jeśli podany adres e-mail jest poprawny, wysłaliśmy na niego link
          umożliwiający zresetowanie hasła.
        </p>
        <p>
          Sprawdź swoją skrzynkę pocztową, również folder spam. <br />
          Link będzie aktywny przez 24 godziny.
        </p>
        <v-btn
          :to="{ name: 'Login' }"
          title="Wróć na stronę logowania"
          rounded
          large
          color="primary"
          elevation="0"
          class="mt-4"
        >
          Wróć na stronę logowania
        </v-btn>
      </div>
      <div v-else>
        <h2 class="label mb-6">
          Wystarczy, że podasz swój e-mail, <br />a my pomożemy Ci ustawić nowe
          hasło.
        </h2>
        <v-form @submit.prevent>
          <validation-observer ref="observer" v-slot="{}">
            <ValidationProvider
              v-slot="{ errors }"
              rules="required|email"
              name="e-mail"
            >
              <v-text-field
                v-model="email"
                label="E-mail"
                placeholder="Wpisz e-mail"
                :error-messages="errors"
                required
                outlined
                autofocus
                persistent-placeholder
              />
            </ValidationProvider>
          </validation-observer>
          <LoginAlerts
            :show="message.show"
            :type="message.color"
            :msg="message.msg"
            @close="message.show = false"
            dismissible
          />

          <div class="actions">
            <div class="actions_links">
              <LibBtnSimple
                color="primary"
                underline
                rounded
                text="Wróć do logowania"
                title="Kliknij, aby zalogować się do Elektronicznego Dziennika Budowy"
                :to="{ name: 'Login' }"
              />
            </div>
            <v-btn
              title="Wyślij email"
              rounded
              large
              color="primary"
              elevation="0"
              class="ml-2"
              @click="forgotPassword"
              :disabled="forgotPasswordDisabled"
            >
              Wyślij email
            </v-btn>
          </div>
        </v-form>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import { extend } from "vee-validate";
setInteractionMode("lazy");
extend("required", required);
extend("email", email);
import axios from "axios";
import LibBtnSimple from "@/components/library/common/LibBtnSimple.vue";
import LoginAlerts from "../components/LoginAlerts.vue";

export default {
  name: "RemaindPassword",
  components: {
    LibBtnSimple,
    ValidationProvider,
    ValidationObserver,
    LoginAlerts,
  },
  data() {
    return {
      email: null,
      forgotPasswordDisabled: false,
      message: {
        timeout: 0,
        text: "",
        color: "error",
        show: false,
        closeAction: () => {},
      },
    };
  },
  computed: {
    showSuccessText() {
      return this.message.color === "success";
    },
  },
  methods: {
    forgotPassword() {
      this.forgotPasswordDisabled = true;
      this.$refs.observer.validate().then((result) => {
        if (result === true)
          axios
            .post(
              `${process.env.VUE_APP_AUTH_REST_URL}/password/notification`,
              { email: this.email }
            )
            .then(({ data }) => {
              if (data.success) {
                this.message.msg =
                  "Na podany email wysłano link resetujący hasło";
                this.message.color = "success";
                this.message.timeout = 5000;
                this.message.show = true;
                this.message.closeAction = () => {
                  window.location.replace("/");
                };
              } else {
                this.message.msg = data.errorMessage;
                this.message.timeout = 0;
                this.message.color = "error";
                this.message.show = true;
                this.message.closeAction = () => {
                  this.message.show = false;
                };
              }
            })
            .catch((er) => {
              this.message.msg = "Błąd. Proszę spróbować poźniej.";
              this.message.timeout = 0;
              this.message.color = "error";
              this.message.show = true;
              this.message.closeAction = () => {
                this.message.show = false;
              };
            })
            .finally(() => {
              this.forgotPasswordDisabled = false;
            });
        else this.forgotPasswordDisabled = false;
      });
    },
  },
  metaInfo: {
    title: "Przypomnienie hasła",
  },
};
</script>
